import { SET_TASKS_LOADING, SET_TASKS_DATA, SET_TASK, DELETE_TASK, SET_TASK_SELECTED, SET_CLIENT_SELECTED, SET_DATE_FILTER, SET_SNAPSHOT } from "../../../actions";
import toPairs from 'lodash.topairs';
import omit from 'lodash.omit';

export const tasks = ( state = {}, action) => {
    switch(action.type) {
        case SET_TASKS_LOADING: {
            return {...state, loading: action.payload.loading }
        }
        case SET_TASKS_DATA: {
            return {...state, loading: false, data: action.payload}
        }
        case SET_TASK: {
            const { task, data } = action.payload;
            return {...state, data: {...state.data, [task]: data} };
        }
        case DELETE_TASK: {
            const { task } = action.payload;
            return {...state, data: omit(state.data, [task]) };
        }
        case SET_TASK_SELECTED: {
            const { taskSelected } = action.payload;
            return {...state, taskSelected}
        }
        case SET_CLIENT_SELECTED: {
            const { clientSelected } = action.payload;
            return {...state, clientSelected }
        }
        case SET_DATE_FILTER: {
            const { dateFilter } = action.payload
            return {...state, dateFilter }
        }
        case SET_SNAPSHOT: {
            const { snapshot } = action.payload
            return {...state, snapshot }
        }
        default:
            return state
    }
}

const fromObjToArray = tasks => (
    toPairs(tasks).map(([key, value]) => ({ ...value, id: key }))
);

export const getTasksData = tasks => fromObjToArray(tasks);